import React, {useState, useEffect} from "react";
import TransferCenterListTable from "./transferCenterListTable/TransferCenterListTable";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {Col, DatePicker, Row, Select} from "antd";
import {CityFilter} from "../../_defaultComponents/FilterComponents";
import DistrictFilter from "../../_defaultComponents/FilterComponents/DistrictFilter";

const TransferCenterList = () => {
    const stores = useStore();
    const [date, setDate] = useState(null);
    const [status, setStatus] = useState("");
    const [supplier, setSupplier] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [page, setPage] = useState(1);

    const [loading, transferCenterList, , , refetchTransferCenterList] = useFetch({
        fetchFn: () =>
            stores.transferStore.transferCenterList({
                page,
                limit: 10,
                date: date ? date.format("YYYY-MM-DD") : "",
                status: status && status !== "all" ? status : undefined,
                city: city && city !== "all" ? city : undefined,
                district: district && district !== "all" ? district : undefined,
                supplierId: supplier && supplier !== "all" ? supplier : undefined
            }),
        dependencies: [page, date, status, city, district, supplier]
    });

    const [supplierLoading, supplierList] = useFetch({
        fetchFn: () => stores.supplierStore.supplierList(),
        dependencies: []
    });

    return (
        <div>
            <h2>Transfer Merkezi</h2>
            <Row gutter={[16, 16]} style={{marginBottom: 24}}>
                <Col xs={24} sm={24} md={12} lg={4}>
                    <h5>Firma</h5>
                    <Select
                        style={{width: "100%"}}
                        value={supplier}
                        onChange={setSupplier}
                        loading={supplierLoading}
                        allowClear
                    >
                        {supplierList?.data?.map(supplier => (
                            <Select.Option key={supplier._id} value={supplier._id}>
                                {supplier.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={24} sm={24} md={12} lg={4}>
                    <CityFilter
                        style={{width: "100%"}}
                        value={city}
                        onChange={setCity}
                        placeholder="Şehir Seçiniz"
                        allowClear
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={4}>
                    <DistrictFilter
                        style={{width: "100%"}}
                        city={city}
                        value={district}
                        onChange={setDistrict}
                        placeholder="İlçe Seçiniz"
                        allowClear
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={4}>
                    <h5>Tarih</h5>
                    <DatePicker
                        style={{width: "100%"}}
                        value={date}
                        onChange={setDate}
                        placeholder="Tarih Seçiniz"
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={4}>
                    <h5>Onay Durumu</h5>
                    <Select style={{width: "100%"}} value={status} onChange={setStatus}>
                        <Select.Option value="all">Tümü</Select.Option>
                        <Select.Option value="pending">Onay Bekliyor</Select.Option>
                        <Select.Option value="active">Onaylandı</Select.Option>
                        <Select.Option value="rejected">Reddedildi</Select.Option>
                    </Select>
                </Col>
            </Row>
            <TransferCenterListTable
                transferCenterList={transferCenterList || {data: [], pagination: {}}}
                loading={loading}
                refetchTransferCenterList={refetchTransferCenterList}
                setPage={setPage}
            />
        </div>
    );
};

export default TransferCenterList;
